import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getPlayers(page, size) {
        let range = 'range=' + encodeURIComponent(`[${page - 1},${size}]`)
        let query = 'filter=' + encodeURIComponent('{"active": true }')
        return api.get(`players?` + (page ? range : '') + query)
    },
    getFilteredPlayers(filter, page, size, sort) {
        return api.get(`players` + buildListQuery({ filter, page, size, sort }))
    },
    getPlayer(id) {
        return api.get(`players/${id}`)
    },

    createPlayer(data) {
        return api.post('players', data)
    },

    updatePlayer(id, data) {
        return api.put(`players/${id}`, data)
    },

    uploadFile(formData) {
        return api.uploadFile('uploads/player', formData)
    },

    deletePlayer(id) {
        return api.delete(`players/${id}`)
    },

    setAlternativeJerseyOnPlayer(id, jersey) {
        return api.post(`players/${id}/alternative-jersey/${encodeURIComponent(jersey)}`, {})
    },

    // back to the official jersey
    clearAlternativeJerseyOnPlayer(id) {
        return api.delete(`players/${id}/alternative-jersey`)
    },

    addPenalties(id, penalties) {
        return api.post(`players/${id}/penalties`, penalties)
    },

    deletePenalty(id, penaltyId) {
        return api.delete(`players/${id}/penalties/${penaltyId}`)
    },

    // active / inactive from the list, without the form
    setActive(id, active) {
        return api.post(`players/${id}/active/${active}`, {})
    },

    setDoctorCheck(id) {
        return api.post(`players/${id}/doctor-check`, {})
    },

    resetDoctorChecks() {
        return api.post(`players/reset-doctor`, {})
    },

    // the players of the current filters as a CSV file
    downloadPlayersCSV(filter) {
        return api.get(`players/export` + buildListQuery({ filter }))
    },

    uploadPlayersCSV(formData) {
        return api.uploadFile('players/import', formData)
    },

    // photo link, full name, birth, team, height and jersey of the players of the current filters
    downloadPlayersInfoCSV(filter) {
        return api.get(`players/export-info` + buildListQuery({ filter }))
    }
}
